import { render, staticRenderFns } from "./ttshop_mycollection.vue?vue&type=template&id=52cf4c63&scoped=true&"
import script from "./ttshop_mycollection.vue?vue&type=script&lang=js&"
export * from "./ttshop_mycollection.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_mycollection.vue?vue&type=style&index=0&id=52cf4c63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cf4c63",
  null
  
)

export default component.exports